import client from '../client/client'

// Howie trigger phrases (MySQL enrichment_embeddings). The backend creates the embeddings on add and edit.
// paginated: params {page, perPage, q}; returns data.data = {channels, total, lastPage}
const getAllEnrichmentPhrasesRequest = async (params: any) => {
  const {data} = await client.get('api/v1/admin/enrichment-phrases', {params: params})
  return data.data
}

// data: {service_id: 5, phrases: ['pixie cut', 'trim my split ends']}
const addEnrichmentPhrasesRequest = async (data: {service_id: number; phrases: string[]}) => {
  try {
    return await client.post('api/v1/admin/enrichment-phrases', data)
  } catch (error) {
    return error
  }
}

// data: {content: 'short bob haircut'}
const updateEnrichmentPhraseRequest = async (content: string, id: string | number) => {
  try {
    return await client.put(`api/v1/admin/enrichment-phrases/${id}`, {content: content})
  } catch (error) {
    return error
  }
}

export {getAllEnrichmentPhrasesRequest, addEnrichmentPhrasesRequest, updateEnrichmentPhraseRequest}
